import type { Company, UserCredentials, UserInfo } from '@entities/user';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';

export interface BusRegistrationFulfilled {
  company?: Company;
  credentials?: UserCredentials;
  currentUser?: UserInfo;
}

export interface BusRegistrationResult extends BusRegistrationFulfilled {
  registered: boolean;
}

export class BusRegistration {
  private static busRegistrationResultPromise: Promise<BusRegistrationResult>;

  static register(iframe: HTMLIFrameElement): Promise<BusRegistrationResult> {
    const event: BusEvent = {
      type: 'BUS.REGISTER',
      payload: {
        origin: window.origin,
        appName: 'salesforce SCV',
        release: '0.0.1',
      },
    };

    return (
      this.busRegistrationResultPromise ??
      (this.busRegistrationResultPromise =
        BusEventsPromisifier.promisifySyncEvent<
          BusRegistrationFulfilled | undefined
        >({
          target: iframe,
          event,
          fulfilled: 'BUS.REGISTER_FULFILLED',
        }).then<BusRegistrationResult>((res) => {
          const result: BusRegistrationResult = {
            registered: true,
            ...res,
          };

          return result;
        }))
    );
  }
}
